const labelsValidationDE = {
    "name": {
        "required": "Name des Labels ist erforderlich",
        "unique": "Ups! Dieses Label existiert bereits und gehört einem anderen Benutzer. Bitte versuchen Sie es mit einem anderen Labelnamen. Wenn Sie diesen Labelnamen rechtmäßig besitzen und das Namensrecht besitzen, kontaktieren Sie bitte unser Support-Team.",
        "available": "Labelname ist verfügbar",
        "invalid": "Labelname ist ungültig"
    },
    "year": {
        "required": "Gründungsjahr ist erforderlich",
        "numeric": "Der Wert ist keine Zahl",
        "stringLength": "Gründungsjahr muss 4-stellig sein"
    },
    "releaseCatalog": {
        "required": "Veröffentlichungen im Katalog sind erforderlich",
        "numeric": "Der Wert ist keine Zahl"
    },
    "logo": {
        "required": "Das Logo ist erforderlich",
        "dimensions": "Die Größe des Label-Logos muss 1000 x 1000 px, JPG/JPEG/PNG sein.",
        "choose": "Bitte wählen Sie ein Bild",
        "file": "Bitte laden Sie JPG- oder PNG-Formate hoch, minimale Auflösung 1000x1000px. Maximalgröße 2MB"
    },
    "promo_graphic": {
        "dimensions": "Die Größe der Label-Werbegrafik muss 960 x 150 px, JPG/JPEG/PNG sein.",
        "choose": "Bitte wählen Sie ein Bild",
        "file": "Laden Sie JPG- oder PNG-Formate hoch, minimale Auflösung 960x150px"
    }
};

export default labelsValidationDE;